import { Injectable } from '@angular/core'
import { Address } from '@spartacus/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export abstract class MbMyAddressesConnector {

  abstract getAllAddresses(): Observable<Address[]>

  abstract getShippingAddresses(): Observable<Address[]>

  abstract getBillingAddresses(): Observable<Address[]>
}
